@if (data) {
  <div class="dialog">
    <div class="header">
      <div class="title-with-count">
        <div class="count">{{data.modaldata.length}}
          <div class="border-none-50"></div>
        </div>
        {{modalname}}
      </div>
      <div style="float: right; margin-top: -20px;">
        <div class="search_panel">
          <div (click)="toggleDateRangeSelector()" class="filterpreset_btn"
            [ngClass]="isDateRangePickerOpen ? 'active' : ''">Custom
          </div>
          <div [ngClass]="{'filterpreset_btn-active':selectedDaysFromNow===90 && !isDateRangePickerOpen }"
            (click)="filterDataByDateRangePreset(90)" class="filterpreset_btn">Last 90 Days
          </div>
          <div [ngClass]="{'filterpreset_btn-active':selectedDaysFromNow===60 && !isDateRangePickerOpen}"
            (click)="filterDataByDateRangePreset(60)" class="filterpreset_btn">Last 60 Days
          </div>
          <div [ngClass]="{'filterpreset_btn-active':selectedDaysFromNow===30 && !isDateRangePickerOpen}"
            (click)="filterDataByDateRangePreset(30)" class="filterpreset_btn">Last 30 Days
          </div>
        </div>
        @if (isDateRangePickerOpen) {
          <div class="daterange_wrapper">
            <input matInput (change)="onChangeStartDate($event.target.value)" type="date" class="filter_panel_control"
              autocomplete="off">
              <span class="delimiter"></span>
              <input matInput (change)="onChageEndDate($event.target.value)" type="date" class="filter_panel_control"
                autocomplete="off">
              </div>
            }
          </div>
          <div class="close-dialog" (click)="cancel()">
            <svg _ngcontent-c12="" fill="none" height="15" viewBox="0 0 15 15" width="15" xmlns="http://www.w3.org/2000/svg"
              class="ng-star-inserted">
              <rect _ngcontent-c12="" fill="white" height="2.12127" rx="1" transform="rotate(-135 13.4996 14.9995)"
              width="19.0914" x="13.4996" y="14.9995"></rect>
              <rect _ngcontent-c12="" fill="white" height="2.12127" rx="1" transform="rotate(135 15.0002 1.50049)"
              width="19.0914" x="15.0002" y="1.50049"></rect>
            </svg>
          </div>
        </div>
        <div class="body">
          <div class="patient-table-data">
            <ng-scrollbar class="patient-table">
              <table mat-table id="PatientDataTable" [dataSource]="patientDataSource" class="patient-table" matSort
                matSortActive="firstName" style="margin-top: 10px;" matSortDirection="asc">
                <!-- Number Column -->
                <ng-container matColumnDef="firstName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="patient-table-header-cell" style="width: 30%;">
                    <div class="header-sort-item">
                      <div class="sort-item-label report-column-header">Patient</div>
                      <div class="sort-item-icon">
                        <svg width="14" height="5" viewBox="0 0 14 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.5 5L7 -6.11959e-07L14 0L10.5 5Z" fill="white" />
                          <path d="M3.5 0L7 5L0 5L3.5 0Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element" class="patient-table-cell bold-font">{{element.firstName}}
                  {{element.lastName}}</td>
                </ng-container>
                <ng-container matColumnDef="cellPhone" style="flex: 0 0 50%;">
                  <th mat-header-cell *matHeaderCellDef class="patient-table-header-cell" style="width: 30%;">
                    <div class="header-sort-item">
                      <div class="sort-item-label report-column-header">Phone Number</div>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element" class="patient-table-cell bold-font">{{element.phone}}</td>
                </ng-container>
                <ng-container matColumnDef="leadSource" style="flex: 0 0 50%;">
                  <th mat-header-cell *matHeaderCellDef class="patient-table-header-cell" style="width: 20%;">
                    <div class="header-sort-item">
                      <div class="sort-item-label report-column-header">Lead Source</div>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element" class="patient-table-cell bold-font">{{(element.leadSource == 'null'
                  || element.leadSource == 'undefined') ? '' : element.leadSource}}</td>
                </ng-container>
                <!-- Submitted Column -->
                <ng-container matColumnDef="createDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="patient-table-header-cell" style="width: 20%;">
                    <div class="header-sort-item">
                      <div class="sort-item-label report-column-header">Date Submitted</div>
                      <div class="sort-item-icon">
                        <svg width="14" height="5" viewBox="0 0 14 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.5 5L7 -6.11959e-07L14 0L10.5 5Z" fill="white" />
                          <path d="M3.5 0L7 5L0 5L3.5 0Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element" class="patient-table-cell">
                  {{element.createDate ? (element.createDate | date:'MM/dd/yyyy') : '&nbsp;'}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="patient-table-header-row"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="patient-table-row"></tr>
              </table>
            </ng-scrollbar>
            <div style="display: inline;">
              <div style="float: right;">
                @if (patientDataSource) {
                  <div class="sub-title">
                    {{patientDataSource.data.length}} Patients found
                    @if (patientDataSource.data.length) {
                      <button class="download-button" cont
                        (click)="exportToCSV()">
                        Download CSV
                      </button>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
